export const lightPurple = 'rgba(244, 245, 253, 0.6)';
export const lightBlue = 'rgba(22,153,213,0.3)';
export const lighterBlue = 'rgba(22,153,213,0.1)';
export const lightGrey = 'rgba(0, 0, 0, 0.12)';
